import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import React, { Component } from 'react';
import FlatList from "react-native-web/dist/exports/FlatList";
import Platform from "react-native-web/dist/exports/Platform";
import Dimensions from "react-native-web/dist/exports/Dimensions";
import ActivityIndicator from "react-native-web/dist/exports/ActivityIndicator";
import View from "react-native-web/dist/exports/View";
import PropTypes from 'prop-types';
import XDate from 'xdate';
import { xdateToData, parseDate } from "../interface";
import styleConstructor from "./style";
import dateutils from "../dateutils";
import Calendar from "../calendar";
import CalendarListItem from "./item";
import CalendarHeader from "../calendar/header/index";
import { STATIC_HEADER } from "../testIDs";
import { jsx as ___EmotionJSX } from "@emotion/core";

var _Dimensions$get = Dimensions.get('window'),
    width = _Dimensions$get.width;

var CalendarList = function (_Component) {
  _inherits(CalendarList, _Component);

  var _super = _createSuper(CalendarList);

  function CalendarList(props) {
    var _this;

    _classCallCheck(this, CalendarList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "addMonth", function (count) {
      _this.updateMonth(_this.state.currentMonth.clone().addMonths(count, true));
    });

    _this.style = styleConstructor(props.theme);
    _this.viewabilityConfig = {
      itemVisiblePercentThreshold: 20
    };
    var rows = [];
    var texts = [];
    var date = parseDate(props.current) || XDate();

    for (var i = 0; i <= _this.props.pastScrollRange + _this.props.futureScrollRange; i++) {
      var rangeDate = date.clone().addMonths(i - _this.props.pastScrollRange, true);
      var rangeDateStr = rangeDate.toString('MMM yyyy');
      texts.push(rangeDateStr);

      if (_this.props.pastScrollRange - 1 <= i && i <= _this.props.pastScrollRange + 1 || !_this.props.pastScrollRange && i <= _this.props.pastScrollRange + 2) {
        rows.push(rangeDate);
      } else {
        rows.push(rangeDateStr);
      }
    }

    _this.state = {
      rows: rows,
      texts: texts,
      openDate: date,
      currentMonth: parseDate(props.current)
    };
    _this.onViewableItemsChangedBound = _this.onViewableItemsChanged.bind(_assertThisInitialized(_this));
    _this.renderCalendarBound = _this.renderCalendar.bind(_assertThisInitialized(_this));
    _this.getItemLayout = _this.getItemLayout.bind(_assertThisInitialized(_this));
    _this.onLayout = _this.onLayout.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(CalendarList, [{
    key: "onLayout",
    value: function onLayout(event) {
      if (this.props.onLayout) {
        this.props.onLayout(event);
      }
    }
  }, {
    key: "scrollToDay",
    value: function scrollToDay(d, offset, animated) {
      var day = parseDate(d);
      var diffMonths = Math.round(this.state.openDate.clone().setDate(1).diffMonths(day.clone().setDate(1)));
      var size = this.props.horizontal ? this.props.calendarWidth : this.props.calendarHeight;
      var scrollAmount = size * this.props.pastScrollRange + diffMonths * size + (offset || 0);

      if (!this.props.horizontal) {
        var week = 0;
        var days = dateutils.page(day, this.props.firstDay);

        for (var i = 0; i < days.length; i++) {
          week = Math.floor(i / 7);

          if (dateutils.sameDate(days[i], day)) {
            scrollAmount += 46 * week;
            break;
          }
        }
      }

      this.listView.scrollToOffset({
        offset: scrollAmount,
        animated: animated
      });
    }
  }, {
    key: "scrollToMonth",
    value: function scrollToMonth(m) {
      var month = parseDate(m);
      var scrollTo = month || this.state.openDate;
      var diffMonths = Math.round(this.state.openDate.clone().setDate(1).diffMonths(scrollTo.clone().setDate(1)));
      var size = this.props.horizontal ? this.props.calendarWidth : this.props.calendarHeight;
      var scrollAmount = size * this.props.pastScrollRange + diffMonths * size;
      this.listView.scrollToOffset({
        offset: scrollAmount,
        animated: false
      });
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(props) {
      var current = parseDate(this.props.current);
      var nextCurrent = parseDate(props.current);

      if (nextCurrent && current && nextCurrent.getTime() !== current.getTime()) {
        this.scrollToMonth(nextCurrent);
      }

      var rowclone = this.state.rows;
      var newrows = [];

      for (var i = 0; i < rowclone.length; i++) {
        var val = this.state.texts[i];

        if (rowclone[i].getTime) {
          val = rowclone[i].clone();
          val.propbump = rowclone[i].propbump ? rowclone[i].propbump + 1 : 1;
        }

        newrows.push(val);
      }

      this.setState({
        rows: newrows
      });
    }
  }, {
    key: "onViewableItemsChanged",
    value: function onViewableItemsChanged(_ref) {
      var viewableItems = _ref.viewableItems;

      function rowIsCloseToViewable(index, distance) {
        for (var i = 0; i < viewableItems.length; i++) {
          if (Math.abs(index - parseInt(viewableItems[i].index)) <= distance) {
            return true;
          }
        }

        return false;
      }

      var rowclone = this.state.rows;
      var newrows = [];
      var visibleMonths = [];

      for (var i = 0; i < rowclone.length; i++) {
        var val = rowclone[i];
        var rowShouldBeRendered = rowIsCloseToViewable(i, 1);

        if (rowShouldBeRendered && !rowclone[i].getTime) {
          val = this.state.openDate.clone().addMonths(i - this.props.pastScrollRange, true);
        } else if (!rowShouldBeRendered) {
          val = this.state.texts[i];
        }

        newrows.push(val);

        if (rowIsCloseToViewable(i, 0)) {
          visibleMonths.push(xdateToData(val));
        }
      }

      if (this.props.onVisibleMonthsChange) {
        this.props.onVisibleMonthsChange(visibleMonths);
      }

      this.setState({
        rows: newrows,
        currentMonth: parseDate(visibleMonths[0])
      });
    }
  }, {
    key: "renderCalendar",
    value: function renderCalendar(_ref2) {
      var item = _ref2.item;
      return ___EmotionJSX(CalendarListItem, _extends({
        testID: this.props.testID + "_" + item,
        scrollToMonth: this.scrollToMonth.bind(this),
        item: item,
        calendarHeight: this.props.calendarHeight,
        calendarWidth: this.props.horizontal ? this.props.calendarWidth : undefined
      }, this.props, {
        style: this.props.calendarStyle
      }));
    }
  }, {
    key: "getItemLayout",
    value: function getItemLayout(data, index) {
      return {
        length: this.props.horizontal ? this.props.calendarWidth : this.props.calendarHeight,
        offset: (this.props.horizontal ? this.props.calendarWidth : this.props.calendarHeight) * index,
        index: index
      };
    }
  }, {
    key: "getMonthIndex",
    value: function getMonthIndex(month) {
      var diffMonths = this.state.openDate.diffMonths(month) + this.props.pastScrollRange;
      return diffMonths;
    }
  }, {
    key: "updateMonth",
    value: function updateMonth(day, doNotTriggerListeners) {
      var _this2 = this;

      if (day.toString('yyyy MM') === this.state.currentMonth.toString('yyyy MM')) {
        return;
      }

      this.setState({
        currentMonth: day.clone()
      }, function () {
        _this2.scrollToMonth(_this2.state.currentMonth);

        if (!doNotTriggerListeners) {
          var currMont = _this2.state.currentMonth.clone();

          if (_this2.props.onMonthChange) {
            _this2.props.onMonthChange(xdateToData(currMont));
          }

          if (_this2.props.onVisibleMonthsChange) {
            _this2.props.onVisibleMonthsChange([xdateToData(currMont)]);
          }
        }
      });
    }
  }, {
    key: "renderStaticHeader",
    value: function renderStaticHeader() {
      var _this$props = this.props,
          staticHeader = _this$props.staticHeader,
          horizontal = _this$props.horizontal;
      var useStaticHeader = staticHeader && horizontal;

      if (useStaticHeader) {
        var indicator;

        if (this.props.showIndicator) {
          indicator = ___EmotionJSX(ActivityIndicator, {
            color: this.props.theme && this.props.theme.indicatorColor
          });
        }

        return ___EmotionJSX(CalendarHeader, {
          style: [this.style.staticHeader, this.props.headerStyle],
          month: this.state.currentMonth,
          addMonth: this.addMonth,
          showIndicator: indicator,
          theme: this.props.theme,
          hideArrows: this.props.hideArrows,
          firstDay: this.props.firstDay,
          renderArrow: this.props.renderArrow,
          monthFormat: this.props.monthFormat,
          hideDayNames: this.props.hideDayNames,
          weekNumbers: this.props.showWeekNumbers,
          onPressArrowLeft: this.props.onPressArrowLeft,
          onPressArrowRight: this.props.onPressArrowRight,
          testID: STATIC_HEADER,
          accessibilityElementsHidden: true,
          importantForAccessibility: 'no-hide-descendants'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return ___EmotionJSX(View, null, ___EmotionJSX(FlatList, {
        testID: this.props.testID,
        onLayout: this.onLayout,
        ref: function ref(c) {
          return _this3.listView = c;
        },
        style: [this.style.container, this.props.style],
        initialListSize: this.props.pastScrollRange + this.props.futureScrollRange + 1,
        data: this.state.rows,
        removeClippedSubviews: this.props.removeClippedSubviews,
        pageSize: 1,
        horizontal: this.props.horizontal,
        pagingEnabled: this.props.pagingEnabled,
        onViewableItemsChanged: this.onViewableItemsChangedBound,
        viewabilityConfig: this.viewabilityConfig,
        renderItem: this.renderCalendarBound,
        showsVerticalScrollIndicator: this.props.showScrollIndicator,
        showsHorizontalScrollIndicator: this.props.showScrollIndicator,
        scrollEnabled: this.props.scrollEnabled,
        keyExtractor: this.props.keyExtractor,
        initialScrollIndex: this.state.openDate ? this.getMonthIndex(this.state.openDate) : false,
        getItemLayout: this.getItemLayout,
        scrollsToTop: this.props.scrollsToTop,
        onEndReachedThreshold: this.props.onEndReachedThreshold,
        onEndReached: this.props.onEndReached,
        keyboardShouldPersistTaps: this.props.keyboardShouldPersistTaps
      }), this.renderStaticHeader());
    }
  }]);

  return CalendarList;
}(Component);

_defineProperty(CalendarList, "displayName", 'CalendarList');

_defineProperty(CalendarList, "propTypes", _objectSpread({}, Calendar.propTypes, {
  pastScrollRange: PropTypes.number,
  futureScrollRange: PropTypes.number,
  scrollEnabled: PropTypes.bool,
  showScrollIndicator: PropTypes.bool,
  scrollsToTop: PropTypes.bool,
  pagingEnabled: PropTypes.bool,
  horizontal: PropTypes.bool,
  calendarWidth: PropTypes.number,
  calendarHeight: PropTypes.number,
  keyboardShouldPersistTaps: PropTypes.oneOf(['never', 'always', 'handled']),
  calendarStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
  staticHeader: PropTypes.bool,
  keyExtractor: PropTypes.func
}));

_defineProperty(CalendarList, "defaultProps", {
  horizontal: false,
  calendarWidth: width,
  calendarHeight: 360,
  pastScrollRange: 50,
  futureScrollRange: 50,
  showScrollIndicator: false,
  scrollEnabled: true,
  scrollsToTop: false,
  removeClippedSubviews: Platform.OS === 'android' ? false : true,
  keyExtractor: function keyExtractor(item, index) {
    return String(index);
  }
});

export default CalendarList;

if (typeof CalendarList !== 'undefined' && CalendarList && CalendarList === Object(CalendarList) && Object.isExtensible(CalendarList) && !CalendarList.hasOwnProperty('__filemeta')) {
  Object.defineProperty(CalendarList, '__filemeta', {
    configurable: true,
    value: {
      name: "CalendarList",
      filename: "node_modules/react-native-calendars/src/calendar-list/index.js"
    }
  });
}